(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-video-carousel"] && !Shopify.designMode) return;
  try {
    

(function () {

  'use strict';


  /*
   * =======================================================
   * IPLUS VIDEO CAROUSEL
   *
   * Transform based carousel
   *
   * Shopify Pipeline compatible
   *
   * No jQuery
   * No third-party library
   * No scrollLeft
   * No scroll-snap
   * =======================================================
   */


  var initializedSections = [];


  /*
   * -------------------------------------------------------
   * EASING
   * -------------------------------------------------------
   */

  function easeOutCubic(t) {

    return 1 - Math.pow(1 - t, 3);

  }


  /*
   * -------------------------------------------------------
   * INITIALIZE
   * -------------------------------------------------------
   */

  function initializeCarousel(section) {

    if (!section) return;


    if (
      section.getAttribute(
        'data-ivc-initialized'
      ) === 'true'
    ) {

      return;

    }


    section.setAttribute(
      'data-ivc-initialized',
      'true'
    );


    initializedSections.push(
      section
    );


    var viewport =
      section.querySelector(
        '[data-ivc-viewport]'
      );


    var track =
      section.querySelector(
        '[data-ivc-track]'
      );


    var previous =
      section.querySelector(
        '[data-ivc-previous]'
      );


    var next =
      section.querySelector(
        '[data-ivc-next]'
      );


    if (
      !viewport ||
      !track
    ) {

      return;

    }


    var cards =
      Array.prototype.slice.call(
        track.querySelectorAll(
          '[data-ivc-card]'
        )
      );


    var videos =
      Array.prototype.slice.call(
        section.querySelectorAll(
          'video'
        )
      );


    if (!cards.length) {

      return;

    }


    var currentIndex = 0;

    var cardWidth = 0;

    var gap = 0;

    var isDragging = false;

    var dragStartX = 0;

    var dragStartTranslate = 0;

    var currentTranslate = 0;

    var animationTimer = null;

    var switchToken = 0;



    /*
     * -------------------------------------------------------
     * GET GAP
     * -------------------------------------------------------
     */

    function getGap() {

      var styles =
        window.getComputedStyle(
          track
        );


      var value =
        parseFloat(
          styles.columnGap ||
          styles.gap ||
          0
        );


      return isNaN(value)
        ? 0
        : value;

    }



    /*
     * -------------------------------------------------------
     * SET CARD WIDTH
     *
     * This avoids percentage width issues
     * inside max-content track.
     * -------------------------------------------------------
     */

    function calculateCardWidth() {

      gap =
        getGap();


      var viewportWidth =
        viewport.clientWidth;


      if (
        window.innerWidth <= 989
      ) {

        /*
          Mobile:
          70% card.
        */

        cardWidth =
          viewportWidth * 0.70;

      } else {

        /*
          Desktop:
          5 cards visible.
        */

        cardWidth =
          (
            viewportWidth -
            gap * 4
          ) / 5;

      }


      if (
        cardWidth < 1
      ) {

        return;

      }


      cards.forEach(
        function (card) {

          card.style.setProperty(
            '--ivc-card-width',
            cardWidth + 'px'
          );

        }
      );


      track.style.setProperty(
        '--ivc-card-width',
        cardWidth + 'px'
      );

    }



    /*
     * -------------------------------------------------------
     * GET TRACK WIDTH
     * -------------------------------------------------------
     */

    function getTrackWidth() {

      if (!cards.length) {

        return 0;

      }


      return (
        cards.length * cardWidth
      ) +
      (
        cards.length - 1
      ) *
      gap;

    }



    /*
     * -------------------------------------------------------
     * GET CENTERED TRANSLATE
     * -------------------------------------------------------
     */

    function getTranslateForIndex(
      index
    ) {

      var viewportWidth =
        viewport.clientWidth;


      var cardCenter =
        index *
        (
          cardWidth +
          gap
        ) +
        cardWidth / 2;


      var viewportCenter =
        viewportWidth / 2;


      /*
       * This is the important part.
       *
       * No fake left/right spacer.
       *
       * The track itself is translated.
       */

      return (
        viewportCenter -
        cardCenter
      );

    }



    /*
     * -------------------------------------------------------
     * STATIC GROUP POSITION
     *
     * For 1-4 videos we initially
     * center the whole group.
     *
     * For 5+ videos, show the first
     * 5 naturally without blank space.
     * -------------------------------------------------------
     */

    function getInitialTranslate() {

      var count =
        cards.length;


      var trackWidth =
        getTrackWidth();


      var viewportWidth =
        viewport.clientWidth;


      if (
        count <= 4
      ) {

        return (
          viewportWidth -
          trackWidth
        ) / 2;

      }


      /*
       * 5+ videos:
       * first 5 fill the viewport.
       */

      return 0;

    }



    /*
     * -------------------------------------------------------
     * APPLY TRANSFORM
     * -------------------------------------------------------
     */

    function applyTranslate(
      value,
      animate
    ) {

      if (!animate) {

        track.style.transition =
          'none';

      } else {

        track.style.transition =
          'transform 520ms cubic-bezier(0.22, 1, 0.36, 1)';

      }


      currentTranslate =
        value;


      track.style.transform =
        'translate3d(' +
        value +
        'px, 0, 0)';


      if (!animate) {

        /*
         * Force browser to acknowledge
         * the no-transition state.
         */

        track.offsetHeight;

        track.style.transition =
          'transform 520ms cubic-bezier(0.22, 1, 0.36, 1)';

      }

    }



    /*
     * -------------------------------------------------------
     * UPDATE ACTIVE VISUAL
     * -------------------------------------------------------
     */

    function updateActiveVisual() {

      cards.forEach(
        function (card, index) {

          if (
            index === currentIndex
          ) {

            card.classList.add(
              'is-active'
            );

          } else {

            card.classList.remove(
              'is-active'
            );

          }

        }
      );

    }



    /*
     * -------------------------------------------------------
     * PAUSE ALL VIDEOS
     * -------------------------------------------------------
     */

    function pauseAllVideos() {

      videos.forEach(
        function (video) {

          try {

            video.pause();

          } catch (error) {}

          video.muted = true;

          video.setAttribute(
            'muted',
            ''
          );

          video.dataset.ivcSound =
            'false';

        }
      );


      section
        .querySelectorAll(
          '[data-ivc-sound]'
        )
        .forEach(
          function (button) {

            button.classList.remove(
              'is-audible'
            );

            button.setAttribute(
              'aria-label',
              'Turn video sound on'
            );

          }
        );

    }



    /*
     * -------------------------------------------------------
     * PLAY ACTIVE VIDEO ONLY
     * -------------------------------------------------------
     */

    function playActiveVideo() {

      var card =
        cards[currentIndex];


      if (!card) return;


      var video =
        card.querySelector(
          'video'
        );


      if (!video) return;


      /*
       * First pause every other video.
       */

      videos.forEach(
        function (otherVideo) {

          if (
            otherVideo !== video
          ) {

            try {

              otherVideo.pause();

            } catch (error) {}

            otherVideo.muted =
              true;

          }

        }
      );


      /*
       * Keep active video muted
       * unless user explicitly enabled sound.
       */

      if (
        video.dataset.ivcSound !==
        'true'
      ) {

        video.muted =
          true;

      }


      video.setAttribute(
        'playsinline',
        ''
      );


      video.setAttribute(
        'webkit-playsinline',
        ''
      );


      /*
       * Only current video plays.
       */

      var promise =
        video.play();


      if (
        promise &&
        typeof promise.catch ===
        'function'
      ) {

        promise.catch(
          function () {}
        );

      }

    }



    /*
     * -------------------------------------------------------
     * SWITCH TO INDEX
     * -------------------------------------------------------
     */

    function switchTo(
      index,
      animate
    ) {

      if (
        !cards.length
      ) {

        return;

      }


      /*
       * Loop navigation.
       */

      if (
        index < 0
      ) {

        index =
          cards.length - 1;

      }


      if (
        index >= cards.length
      ) {

        index = 0;

      }


      currentIndex =
        index;


      switchToken += 1;

      var token =
        switchToken;


      /*
       * Stop current video immediately.
       */

      pauseAllVideos();


      /*
       * Update visual state immediately.
       */

      updateActiveVisual();


      /*
       * Cancel previous play timer.
       */

      if (
        animationTimer
      ) {

        window.clearTimeout(
          animationTimer
        );

      }


      var targetTranslate;


      /*
       * For a normal carousel:
       * center the active card.
       */

      targetTranslate =
        getTranslateForIndex(
          currentIndex
        );


      /*
       * For the initial static state,
       * don't create a blank area.
       */

      if (
        !animate &&
        cards.length <= 4
      ) {

        targetTranslate =
          getInitialTranslate();

      }


      applyTranslate(
        targetTranslate,
        animate
      );


      /*
       * Start video only after
       * transition has completed.
       */

      if (animate) {

        animationTimer =
          window.setTimeout(
            function () {

              if (
                token !==
                switchToken
              ) {

                return;

              }


              playActiveVideo();

            },
            520
          );

      } else {

        /*
         * Let layout settle first.
         */

        window.requestAnimationFrame(
          function () {

            if (
              token !==
              switchToken
            ) {

              return;

            }

            playActiveVideo();

          }
        );

      }

    }



    /*
     * -------------------------------------------------------
     * RESIZE
     * -------------------------------------------------------
     */

    var resizeTimer =
      null;


    function handleResize() {

      if (
        resizeTimer
      ) {

        window.clearTimeout(
          resizeTimer
        );

      }


      resizeTimer =
        window.setTimeout(
          function () {

            calculateCardWidth();


            /*
             * Recalculate without animation.
             */

            var target;


            if (
              cards.length <= 4
            ) {

              target =
                getInitialTranslate();

            } else {

              target =
                getTranslateForIndex(
                  currentIndex
                );

            }


            applyTranslate(
              target,
              false
            );

          },
          120
        );

    }


    window.addEventListener(
      'resize',
      handleResize
    );



    /*
     * -------------------------------------------------------
     * ARROWS
     * -------------------------------------------------------
     */

    if (previous) {

      previous.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          switchTo(
            currentIndex - 1,
            true
          );

        }
      );

    }


    if (next) {

      next.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          switchTo(
            currentIndex + 1,
            true
          );

        }
      );

    }



    /*
     * -------------------------------------------------------
     * KEYBOARD
     * -------------------------------------------------------
     */

    track.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key ===
          'ArrowLeft'
        ) {

          event.preventDefault();

          switchTo(
            currentIndex - 1,
            true
          );

        }


        if (
          event.key ===
          'ArrowRight'
        ) {

          event.preventDefault();

          switchTo(
            currentIndex + 1,
            true
          );

        }

      }
    );



    /*
     * -------------------------------------------------------
     * DRAG / TOUCH
     * -------------------------------------------------------
     */

    var pointerStartX =
      0;

    var pointerCurrentX =
      0;

    var pointerActive =
      false;


    function getPointerX(event) {

      if (
        event.touches &&
        event.touches.length
      ) {

        return event.touches[0].clientX;

      }


      if (
        event.changedTouches &&
        event.changedTouches.length
      ) {

        return event.changedTouches[0].clientX;

      }


      return event.clientX;

    }


    function startDrag(event) {

      /*
       * Don't start carousel dragging
       * from the sound button.
       */

      var target =
        event.target;


      if (
        target &&
        target.closest &&
        target.closest(
          '[data-ivc-sound]'
        )
      ) {

        return;

      }


      pointerActive =
        true;


      pointerStartX =
        getPointerX(event);


      pointerCurrentX =
        pointerStartX;


      dragStartTranslate =
        currentTranslate;


      track.classList.add(
        'is-dragging'
      );


      /*
       * Stop video during drag.
       */

      pauseAllVideos();

    }


    function moveDrag(event) {

      if (!pointerActive) {

        return;

      }


      pointerCurrentX =
        getPointerX(event);


      var delta =
        pointerCurrentX -
        pointerStartX;


      /*
       * Prevent huge dragging.
       */

      var maxDrag =
        viewport.clientWidth * 0.85;


      if (
        delta > maxDrag
      ) {

        delta =
          maxDrag;

      }


      if (
        delta < -maxDrag
      ) {

        delta =
          -maxDrag;

      }


      track.style.transition =
        'none';


      currentTranslate =
        dragStartTranslate +
        delta;


      track.style.transform =
        'translate3d(' +
        currentTranslate +
        'px, 0, 0)';

    }


    function endDrag() {

      if (!pointerActive) {

        return;

      }


      pointerActive =
        false;


      track.classList.remove(
        'is-dragging'
      );


      var delta =
        pointerCurrentX -
        pointerStartX;


      var threshold =
        Math.max(
          45,
          viewport.clientWidth * 0.08
        );


      /*
       * Swipe left.
       */

      if (
        delta <
        -threshold
      ) {

        switchTo(
          currentIndex + 1,
          true
        );

        return;

      }


      /*
       * Swipe right.
       */

      if (
        delta >
        threshold
      ) {

        switchTo(
          currentIndex - 1,
          true
        );

        return;

      }


      /*
       * Not enough movement:
       * smoothly return to active card.
       */

      switchTo(
        currentIndex,
        true
      );

    }


    /*
     * Pointer events.
     */

    track.addEventListener(
      'pointerdown',
      startDrag
    );


    track.addEventListener(
      'pointermove',
      moveDrag
    );


    track.addEventListener(
      'pointerup',
      endDrag
    );


    track.addEventListener(
      'pointercancel',
      endDrag
    );


    track.addEventListener(
      'pointerleave',
      function () {

        if (
          pointerActive
        ) {

          endDrag();

        }

      }
    );


    /*
     * Prevent native image/video dragging.
     */

    track.addEventListener(
      'dragstart',
      function (event) {

        event.preventDefault();

      }
    );



    /*
     * -------------------------------------------------------
     * SOUND BUTTON
     * -------------------------------------------------------
     */

    var soundButtons =
      section.querySelectorAll(
        '[data-ivc-sound]'
      );


    Array.prototype.forEach.call(
      soundButtons,
      function (button) {

        button.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            event.stopPropagation();


            var card =
              button.closest(
                '[data-ivc-card]'
              );


            if (!card) return;


            var cardIndex =
              cards.indexOf(
                card
              );


            if (
              cardIndex < 0
            ) {

              return;

            }


            /*
             * If clicking sound on
             * a non-active card,
             * move it to center first.
             */

            if (
              cardIndex !==
              currentIndex
            ) {

              switchTo(
                cardIndex,
                true
              );


              /*
               * Enable sound after
               * transition.
               */

              var token =
                switchToken;


              window.setTimeout(
                function () {

                  if (
                    token !==
                    switchToken
                  ) {

                    return;

                  }


                  enableSound(
                    button,
                    card
                  );

                },
                540
              );


              return;

            }


            toggleSound(
              button,
              card
            );

          }
        );

      }
    );



    /*
     * -------------------------------------------------------
     * SOUND HELPERS
     * -------------------------------------------------------
     */

    function enableSound(
      button,
      card
    ) {

      var video =
        card.querySelector(
          'video'
        );


      if (!video) return;


      pauseAllVideos();


      /*
       * Restore active video state.
       */

      video.muted =
        false;

      video.dataset.ivcSound =
        'true';


      button.classList.add(
        'is-audible'
      );


      button.setAttribute(
        'aria-label',
        'Turn video sound off'
      );


      video.play().catch(
        function () {}
      );

    }


    function toggleSound(
      button,
      card
    ) {

      var video =
        card.querySelector(
          'video'
        );


      if (!video) return;


      var turnOn =
        video.muted;


      /*
       * Mute all other videos.
       */

      videos.forEach(
        function (otherVideo) {

          if (
            otherVideo !== video
          ) {

            otherVideo.muted =
              true;

            otherVideo.dataset.ivcSound =
              'false';

          }

        }
      );


      section
        .querySelectorAll(
          '[data-ivc-sound]'
        )
        .forEach(
          function (otherButton) {

            if (
              otherButton !== button
            ) {

              otherButton.classList.remove(
                'is-audible'
              );

              otherButton.setAttribute(
                'aria-label',
                'Turn video sound on'
              );

            }

          }
        );


      video.muted =
        !turnOn;


      video.dataset.ivcSound =
        turnOn
          ? 'true'
          : 'false';


      button.classList.toggle(
        'is-audible',
        turnOn
      );


      button.setAttribute(
        'aria-label',
        turnOn
          ? 'Turn video sound off'
          : 'Turn video sound on'
      );


      video.play().catch(
        function () {}
      );

    }



    /*
     * -------------------------------------------------------
     * VIDEO EVENTS
     *
     * IMPORTANT:
     * Only active video can play.
     * -------------------------------------------------------
     */

    videos.forEach(
      function (video) {

        /*
         * Remove autoplay if Shopify
         * has inserted it.
         */

        video.removeAttribute(
          'autoplay'
        );


        video.setAttribute(
          'preload',
          'metadata'
        );


        video.setAttribute(
          'playsinline',
          ''
        );


        video.setAttribute(
          'webkit-playsinline',
          ''
        );


        video.muted =
          true;


        video.dataset.ivcSound =
          'false';


        /*
         * Make sure every video starts paused.
         */

        try {

          video.pause();

        } catch (error) {}


        /*
         * If video becomes ready,
         * play ONLY if it is active.
         */

        video.addEventListener(
          'canplay',
          function () {

            var card =
              video.closest(
                '[data-ivc-card]'
              );


            if (!card) return;


            var index =
              cards.indexOf(
                card
              );


            if (
              index ===
              currentIndex
            ) {

              playActiveVideo();

            }

          }
        );

      }
    );



    /*
     * -------------------------------------------------------
     * INITIAL LAYOUT
     * -------------------------------------------------------
     */

    calculateCardWidth();


    /*
     * Initial active card:
     *
     * 1 video  -> 0
     * 2 videos -> 0
     * 3 videos -> 1
     * 4 videos -> 1
     * 5+       -> 2
     */

    if (
      cards.length <= 2
    ) {

      currentIndex =
        0;

    } else if (
      cards.length <= 4
    ) {

      currentIndex =
        Math.floor(
          (cards.length - 1) / 2
        );

    } else {

      currentIndex =
        2;

    }


    updateActiveVisual();


    /*
     * Static position:
     *
     * 1-4:
     * entire group centered,
     * no fake left blank.
     *
     * 5+:
     * natural first five-card layout.
     */

    var initialTranslate;


    if (
      cards.length <= 4
    ) {

      initialTranslate =
        getInitialTranslate();

    } else {

      initialTranslate =
        getTranslateForIndex(
          currentIndex
        );

    }


    applyTranslate(
      initialTranslate,
      false
    );


    /*
     * Play only initial active video.
     */

    window.requestAnimationFrame(
      function () {

        playActiveVideo();

      }
    );

  }



  /*
   * =======================================================
   * INITIALIZE ALL
   * =======================================================
   */

  function initializeAll() {

    var sections =
      document.querySelectorAll(
        '[data-ivc-section]'
      );


    Array.prototype.forEach.call(
      sections,
      function (section) {

        initializeCarousel(
          section
        );

      }
    );

  }



  /*
   * =======================================================
   * DOM READY
   * =======================================================
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeAll
    );

  } else {

    initializeAll();

  }



  /*
   * =======================================================
   * SHOPIFY PIPELINE / THEME EDITOR
   * =======================================================
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var section =
        event.target;


      if (!section) return;


      var carousel =
        section.matches &&
        section.matches(
          '[data-ivc-section]'
        )
          ? section
          : section.querySelector &&
            section.querySelector(
              '[data-ivc-section]'
            );


      if (carousel) {

        /*
         * Shopify Theme Editor may
         * reload the same section.
         */

        carousel.removeAttribute(
          'data-ivc-initialized'
        );


        initializeCarousel(
          carousel
        );

      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();
})();
